import {
    DeviceUnlocker,
    EmailAddressChange,
    Maintenance,
    NewDashboard,
    RecoveryCodes,
    RemoveCompanyId,
    RoleRemoval,
    RolesAndPermissions,
    ScheduleByDate,
    SmartDeviceGroups,
    TwoFactorAuth,
    UserAccessControl
} from "assets/newsImages";

import { NewsData } from "../types";
import {
    News1,
    News2,
    News3,
    News4,
    News5,
    News6,
    News7,
    News8,
    News9,
    News10,
    News11,
    News12,
    News13
} from "./body";

const news: NewsData[] = [
    {
        id: 1,
        createdAt: "2025-01-07",
        body: <News1 />,
        image: TwoFactorAuth
    },
    {
        id: 2,
        createdAt: "2025-05-27",
        body: <News2 />,
        image: Maintenance
    },
    {
        id: 3,
        createdAt: "2025-06-17",
        body: <News3 />,
        image: DeviceUnlocker
    },
    {
        id: 4,
        createdAt: "2025-07-22",
        body: <News4 />,
        image: NewDashboard
    },
    {
        id: 5,
        createdAt: "2025-08-27",
        body: <News5 />,
        image: RoleRemoval
    },
    {
        id: 6,
        createdAt: "2025-10-29",
        body: <News6 />,
        image: RolesAndPermissions
    },
    {
        id: 7,
        createdAt: "2025-11-17",
        body: <News7 />,
        image: ScheduleByDate
    },
    {
        id: 8,
        createdAt: "2026-02-12",
        body: <News8 />,
        image: UserAccessControl
    },
    {
        id: 9,
        createdAt: "2026-03-06",
        body: <News9 />,
        image: SmartDeviceGroups
    },
    {
        id: 10,
        createdAt: "2026-03-19",
        body: <News10 />,
        image: EmailAddressChange
    },
    {
        id: 11,
        createdAt: "2026-03-30",
        body: <News11 />,
        image: RecoveryCodes
    },
    {
        id: 12,
        createdAt: "2026-04-20",
        body: <News12 />,
        image: Maintenance
    },
    {
        id: 13,
        createdAt: "2026-06-15",
        body: <News13 />,
        image: RemoveCompanyId
    }
];

export { news };
